<div *ngIf="formObject">
  <mat-form-field appearance="standard" class="w-100">
    <mat-label [ngStyle]="isFirst ? {'visibility': 'visible'} : {'visibility' : 'hidden'}">{{label}}
      <sup *ngIf="isInfo">
        <mat-icon class="fas fa-info" style="font-size: 0.5rem"></mat-icon>
      </sup>
    </mat-label>
    <input matInput #inputElement min="0" type="number"
           [(ngModel)]="ngModelObject"
           [name]="elementName"
           [placeholder]="label"
           [disabled]="isDisabled"
           (focusout)="emitValue()"
           (ngModelChange)="updateValue($event)">
  </mat-form-field>
</div>
